module.exports = __webpack_public_path__ + "img/shopCart.a5e96674.png";